import {createSlice, Dispatch} from "@reduxjs/toolkit";
import {errorMsg, successMsg} from "app/utils/MessageUtils";
import {getApiErrorMessage} from "app/utils/getApiErrorMessage";
import {ReservationService} from "app/services";
import {filterSchedules} from "./filter-schedules.slice";
import store from "../../../store";

interface DeleteFlightFromTraveler {
  travelerId: string;
  flight: string;
  onSuccess?: Function;
  onError?: Function;
}

export const deleteFlight =
    (params: DeleteFlightFromTraveler) => async (dispatch: Dispatch) => {
      const filters = store.getState().schedules.filterSchedules;
      try {
        dispatch(setLoading(true));
        const response = await ReservationService.deleteFlight(
            params.travelerId,
            params.flight
        );
        if (response.status >= 200 && response.status < 300) {
          dispatch(setSuccess(true));
          dispatch(successMsg(localStorage.getItem('i18nextLng') === 'en' ? 'Flight deleted successfully!' : 'Fluturimi u fshi me sukses!'));
          if (params.onSuccess) params.onSuccess();
          dispatch(setError(""));
          // @ts-ignore
          dispatch(
              // @ts-ignore
              filterSchedules({
                ...filters,
                page: 0,
              })
          );
        }
      } catch (err: unknown) {
        const message = getApiErrorMessage(err);

        dispatch(errorMsg(message));
        if (params.onError) params.onError(err);
        dispatch(setError(message));
      } finally {
        dispatch(setLoading(false));
      }
    };

interface DeleteFlightFromTravelerSlice {
  success: boolean;
  error: string;
  loading: boolean;
}

const initialState: DeleteFlightFromTravelerSlice = {
  error: "",
  success: false,
  loading: false,
};

const stateSlice = createSlice({
  name: "schedules/flight-traveler/delete",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const {setLoading, setSuccess, setError} = stateSlice.actions;

export default stateSlice.reducer;
